// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-card[data-v-b067bbd2] {\n  width: 20rem;\n  margin: 2rem auto;\n}\n.box-card .headerText[data-v-b067bbd2] {\n  color: #69b2fd;\n  font-size: 20px;\n}\n.box-card .copy[data-v-b067bbd2] {\n  margin-left: 1rem;\n  color: #69b2fd;\n}\n.box-card .custom-tree-node[data-v-b067bbd2] {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 14px;\n  padding-right: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
